import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import { useState } from 'react';
export default function useEvents() {
    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const authenticatedApi = useAuthenticatedApi();
    const { orgId } = useUserOrg();

    const getEvents = async () => {
        setIsLoading(true);
        const response = await authenticatedApi.get(`/${orgId}/activations`);

        if (response.data) {
            setEvents(response.data);
        }
        setIsLoading(false);
    };

    const getActivationPhotoStats = async (activationId: number) => {
        const response = await authenticatedApi.get(
            `/${orgId}/activations/${activationId}/photoStats`,
        );
        return response.data;
    };

    const getEventDetails = async (activationId: number) => {
        const response = await authenticatedApi.get(
            `/${orgId}/activations/v2/${activationId}`,
        );
        return response.data;
    };

    return {
        events,
        isLoading,
        getEvents,
        getActivationPhotoStats,
        getEventDetails,
    };
}
